import React, { createContext, useState, useContext, useEffect } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  // Boshlang'ich qiymatni localStorage'dan qidiramiz, yo'q bo'lsa 'dark' qo'yamiz
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('smm_crm_theme');
    return savedTheme ? savedTheme : 'dark';
  });
  
  // Tema o'zgarganda uni localStorage'ga saqlab qo'yamiz
  useEffect(() => {
    localStorage.setItem('smm_crm_theme', theme);
  }, [theme]);
  
  const toggleTheme = () => setTheme(theme === 'light' ? 'dark' : 'light');

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      <div className={theme} style={{ 
        background: theme === 'light' ? '#f1f5f9' : '#0f172a', 
        color: theme === 'light' ? '#000' : '#fff',
        minHeight: '100vh', 
        transition: '0.3s' 
      }}>
        {children}
      </div>
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);